import { Component, OnInit, inject } from '@angular/core';
import { PortalService } from '../portal.service';
import { TranslateModule } from '@ngx-translate/core';
import { PortalMetricsComponent } from '../portal-metrics/portal-metrics.component';
import { DeferLoadModule } from '@trademe/ng-defer-load';
import { CenteredBlockLayoutComponent } from '@exl-ng/mulo-views';


@Component({
    selector: 'esp-portal-usage',
    templateUrl: './portal-usage.component.html',
    styleUrls: ['./portal-usage.component.scss'],
    imports: [
        CenteredBlockLayoutComponent,
        DeferLoadModule,
        PortalMetricsComponent,
        TranslateModule
    ]
})
export class PortalUsageComponent implements OnInit {
    private portalService = inject(PortalService);

    showMetricsTotals = false;
    loading;

    totalAssets = [
        {
            name: 'research.portal.metrics.total',
            value: 0,
            icon: 'database',
        },
        {
            name: 'research.portal.metrics.views',
            value: 0,
            icon: 'eye-outline',
        },
        {
            name: 'research.portal.metrics.downloads',
            value: 0,
            icon: 'cloud-download',
        },
    ];

    ngOnInit() {
        this.getUsage();
    }

    getUsage() {
        this.getTotalAssetsCount();
        this.getAssetsUsage();
    }

    getTotalAssetsCount() {
        this.portalService.getTotalAssetsCount().subscribe((data) => {
            if (data) {
                const total = data as number;
                this.totalAssets[0].value = total;
            }
        });
    }

    getAssetsUsage() {
        this.portalService.getAssetsUsage().subscribe((data) => {
            if (data) {
                const assetsUsage = data;
                this.totalAssets[1].value = parseInt(assetsUsage.views);
                this.totalAssets[2].value = parseInt(assetsUsage.downloads);
            }
        });
    }
}
